
<div class="page-header">
  <div>
    <h1>Meus usuários</h1>
    <p>Cadastre e gerencie usuários vinculados ao seu parceiro.</p>
  </div>

  <button
    type="button"
    class="btn btn-primary"
    (click)="novo()"
    [disabled]="salvando || carregandoDetalhe">
    + Novo usuário
  </button>
</div>

<p *ngIf="erro" class="error-message">{{ erro }}</p>
<p *ngIf="sucesso" class="success-message">{{ sucesso }}</p>

<div class="card" *ngIf="mostrar">
  <div class="form-header">
    <h3>{{ editando ? 'Editar usuário' : 'Cadastrar usuário' }}</h3>
    <p>Preencha os dados pessoais e o contato de emergência.</p>
  </div>

  <form (ngSubmit)="salvar()" #usuarioForm="ngForm">

    <h4 class="section-title">Dados pessoais</h4>

    <div class="form-grid">

      <div class="form-group">
        <label for="nome">Nome completo *</label>
        <input
          id="nome"
          class="form-control"
          name="nome"
          type="text"
          maxlength="150"
          autocomplete="name"
          [(ngModel)]="form.nome"
          placeholder="Nome completo"
          required>
      </div>

      <div class="form-group">
        <label for="telefone">Telefone / WhatsApp *</label>
        <input
          id="telefone"
          class="form-control"
          name="telefone"
          type="tel"
          inputmode="tel"
          autocomplete="tel"
          [ngModel]="form.telefone"
          (ngModelChange)="mascaraTelefoneUsuario($event)"
          placeholder="(62) 99999-9999"
          maxlength="19"
          required>
      </div>

      <div class="form-group">
        <label for="email">E-mail</label>
        <input
          id="email"
          class="form-control"
          name="email"
          type="email"
          autocomplete="email"
          [(ngModel)]="form.email"
          placeholder="usuario@email.com"
          email>
      </div>

      <div class="form-group">
        <label for="dataNascimento">Data de nascimento</label>
        <input
          id="dataNascimento"
          class="form-control"
          name="dataNascimento"
          type="text"
          inputmode="numeric"
          [ngModel]="form.dataNascimento"
          (ngModelChange)="mascaraData($event)"
          placeholder="DD/MM/AAAA"
          maxlength="10">
      </div>

    </div>

    <h4 class="section-title">Mobilidade e acessibilidade</h4>

    <div class="form-grid">
      <div class="form-group full-width">

        <label class="checkbox-label">
          <input
            type="checkbox"
            name="possuiLimitacaoFisica"
            [(ngModel)]="form.possuiLimitacaoFisica">
          Possui alguma limitação física ou de mobilidade?
        </label>

      </div>

      <div
        class="form-group full-width"
        *ngIf="form.possuiLimitacaoFisica">

        <label for="informacaoMobilidade">
          Informações sobre mobilidade
        </label>

        <textarea
          id="informacaoMobilidade"
          class="form-control"
          name="informacaoMobilidade"
          [(ngModel)]="form.informacaoMobilidade"
          rows="3"
          placeholder="Descreva as necessidades de mobilidade do usuário">
        </textarea>

      </div>
    </div>

    <h4 class="section-title">Contato de emergência</h4>

    <div class="form-group full-width">
      <label class="checkbox-label">
        <input
          type="checkbox"
          name="usarDadosParceiro"
          [(ngModel)]="form.usarDadosParceiro">
        Utilizar meus dados de parceiro como contato de emergência
      </label>

      <p class="field-hint" *ngIf="form.usarDadosParceiro">
        O nome, telefone e e-mail do parceiro serão preenchidos
        automaticamente pelo sistema.
      </p>
    </div>

    <div class="form-grid" *ngIf="!form.usarDadosParceiro">

      <div class="form-group">
        <label for="emergenciaNome">Nome do contato *</label>
        <input
          id="emergenciaNome"
          class="form-control"
          name="emergenciaNome"
          type="text"
          [(ngModel)]="form.emergenciaNome"
          placeholder="Nome do contato de emergência"
          required>
      </div>

      <div class="form-group">
        <label for="emergenciaTelefone">Telefone do contato *</label>
        <input
          id="emergenciaTelefone"
          class="form-control"
          name="emergenciaTelefone"
          type="tel"
          inputmode="tel"
          [ngModel]="form.emergenciaTelefone"
          (ngModelChange)="mascaraTelefoneEmergencia($event)"
          placeholder="(62) 99999-9999"
          maxlength="19"
          required>
      </div>

      <div class="form-group">
        <label for="emergenciaEmail">E-mail do contato</label>
        <input
          id="emergenciaEmail"
          class="form-control"
          name="emergenciaEmail"
          type="email"
          [(ngModel)]="form.emergenciaEmail"
          placeholder="contato@email.com"
          email>
      </div>

    </div>

    <div class="actions">
      <button
        type="button"
        class="btn btn-outline"
        (click)="cancelar()"
        [disabled]="salvando">
        Cancelar
      </button>


      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="salvando || carregandoDetalhe">
        {{ salvando ? 'Salvando...' : (editando ? 'Salvar alterações' : 'Cadastrar usuário') }}
      </button>

    </div>

  </form>
</div>

<div class="card">

  <div class="table-container">
    <table>
      <thead>
      <tr>
        <th>Nome</th>
        <th>Telefone</th>
        <th>Plano</th>
        <th>Status</th>
        <th>Ações</th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let u of items">

        <td>
          <strong>{{ u.nome }}</strong>
        </td>

        <td>{{ formatarTelefone(u.telefone) }}</td>

        <td>{{ u.plano || 'Sem plano' }}</td>

        <td>
            <span
              class="status-badge"
              [class.status-active]="u.ativo"
              [class.status-inactive]="!u.ativo">
              {{ u.ativo ? 'Ativo' : 'Inativo' }}
            </span>
        </td>

        <td>
          <div class="table-actions">

            <button
              type="button"
              class="btn btn-outline"
              (click)="editar(u)"
              [disabled]="salvando || excluindo || carregandoDetalhe">
              {{ carregandoDetalhe ? 'Carregando...' : 'Editar' }}
            </button>

            <button
              *ngIf="u.ativo"
              type="button"
              class="btn btn-danger"
              (click)="excluir(u)"
              [disabled]="excluindo || salvando">
              Inativar
            </button>

            <button
              *ngIf="!u.ativo && u.plano === null"
              type="button"
              class="btn btn-outline"
              (click)="reativar(u)"
              [disabled]="excluindo || salvando">
              Reativar
            </button>

          </div>
        </td>

      </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="carregando" class="empty-state">
    Carregando usuários...
  </p>

  <p
    *ngIf="!carregando && !items.length"
    class="empty-state">
    Nenhum usuário encontrado.
  </p>

</div>
